import styled from 'styled-components';
import TablePlaceholder, { ITablePlaceholderProps } from './TablePlaceholder';
import { printStyles, table1Styles } from './TableStyles';
import { IStyledTableProps, ITableProps } from './TableTypes';

export const StyledTableWrapper = styled.div<{
  $isPadded: boolean | undefined;
}>`
  max-width: 100%;
  overflow: auto;
  ${props => (props.$isPadded ? 'padding: 0 20px;' : '')}
`;

const StyledTablePlaceholderWrapper = styled.div`
  padding: 48px 20px;
`;

const StyledTable = styled.table<IStyledTableProps>`
  ${props => {
    switch (props.$config?.layout) {
      case 'table1':
        return table1Styles;
      case 'print':
        return printStyles;
      default:
        return null;
    }
  }}
`;

const Table: React.FC<ITableProps> = ({
  config,
  rows,
  headerRows,
  footerRows,
  placeholderData
}) => {
  const classes: string[] = [];
  if (config?.table?.highlightAlternateRows) classes.push('alternate-rows');
  return rows?.length ? (
    <StyledTableWrapper $isPadded={config?.table?.isPadded}>
      <StyledTable $config={config} className={classes.join(' ')}>
        {headerRows?.length ? <thead>{headerRows}</thead> : undefined}
        {footerRows?.length ? <tfoot>{footerRows}</tfoot> : undefined}
        <tbody>{rows}</tbody>
      </StyledTable>
    </StyledTableWrapper>
  ) : (
    <StyledTablePlaceholderWrapper>
      <TablePlaceholder
        {...(placeholderData ?? ({} as ITablePlaceholderProps))}
      />
    </StyledTablePlaceholderWrapper>
  );
};

export default Table;
